import { Injectable, Injector, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AccessMenuGuard implements CanActivate, CanActivateChild {
    protected readonly _authService: AuthenticationService;

    constructor(protected injector: Injector) {
        this._authService = injector.get(AuthenticationService);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this._authService.isLoggedIn().then(res => {
            var fromRoute: string = state.url;
            //If the user is not logged, redirect to login with asked page as a parameter
            if (!res) {
                this._authService.navigate('/' + this._authService.loginPageRoute, { queryParams: { fromRoute: fromRoute } });
                return false;
            }
        });

        let path: string = state.url;
        if (path && path[0] === '/') path = path.substr(1);

        return this._authService.hasRight(path);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }
}
